import type { FormResponse } from '@piccolohealth/pbs-common';
import { ChakraV3, FancyDate, ScrollArea } from '@piccolohealth/ui';
import { P } from '@piccolohealth/util';
import React from 'react';
import { FormResponseStatusTag } from './FormResponseStatusTag';

interface FormResponseSummaryProps {
  formResponse: FormResponse;
}

type FormField = {
  key: string;
  label: string;
  type: string;
  value: string | string[] | number | number[] | null;
};

export const FormResponseSummary = (props: FormResponseSummaryProps) => {
  const { formResponse } = props;

  const renderedFields = formResponse.response.data.fields.map((field: FormField) => {
    const value = P.isArray(field.value)
      ? field.value.map((item: string | number) => item.toString()).join(', ')
      : (field.value?.toString() ?? '-');

    return (
      <ChakraV3.DataList.Item key={field.label} pt='4'>
        <ChakraV3.DataList.ItemLabel fontSize='md' fontWeight='semibold'>
          {field.label}
        </ChakraV3.DataList.ItemLabel>
        <ChakraV3.DataList.ItemValue>{value}</ChakraV3.DataList.ItemValue>
      </ChakraV3.DataList.Item>
    );
  });

  return (
    <ChakraV3.Stack pl={8} h='full'>
      <ChakraV3.Stack gap={0}>
        <ChakraV3.HStack>
          <ChakraV3.Heading size='lg' fontWeight='bold'>
            Response {formResponse.submissionId}
          </ChakraV3.Heading>
          <FormResponseStatusTag status={formResponse.status} />
        </ChakraV3.HStack>
        <FancyDate
          fontSize='xs'
          color='secondary'
          date={formResponse.createdAt}
          showTooltip={false}
          direction='row'
        />
      </ChakraV3.Stack>

      <ChakraV3.Separator />
      <ScrollArea h='full'>
        <ChakraV3.DataList.Root orientation='vertical' variant='bold' maxW='lg'>
          {renderedFields}
        </ChakraV3.DataList.Root>
      </ScrollArea>
    </ChakraV3.Stack>
  );
};
